export const planData = [
  {
    id: 0,
    name: 'Start',
    period: 'mês',
    price: 247.00,
    description: 'Para quem está iniciando na automação de tarefas',
    features: [
      '1 Agente de IA',
      '50 conversas/mês',
      'Suporte via comunidade',
      'Integração com WhatsApp',
    ],
    unavailableFeatures: ['Integração com WhatsApp'],
    link: '#',
    recommended: true,
  },
  {
    id: 1,
    name: 'Growth',
    period: 'mês',
    price: 637.00,
    price_description: '25% de desconto no plano anual',
    description: 'Perfeito para dar os primeiros passos e automatizar tarefas',
    features: [
      '3 Agentes de IA',
      '500 conversas/mês',
      'Suporte via comunidade',
      'Integração com WhatsApp',
    ],
    link: 'https://verboo.ai/lab/solicitar-agente?planType=1',
    recommended: false,
  },
]
